import { withTranslations } from '@/utils/Language';
import assessmentsEn from '@/assets/i18n/assessments/en.json';
import uiEn from '@/assets/i18n/ui/en.json';
import languagesEn from '@/assets/i18n/languages/default.json';
import languagesTranslatedEn from '@/assets/i18n/languages_translated/en.json';

const enDefault = { ...assessmentsEn, ...uiEn, ...languagesEn, ...languagesTranslatedEn };

export default withTranslations(
  (lang) =>
    Promise.all([
      import(`@/assets/i18n/assessments/${lang}.json`),
      import(`@/assets/i18n/ui/${lang}.json`),
      import('@/assets/i18n/languages/default.json'),
      import(`@/assets/i18n/languages_translated/${lang}.json`)
    ]).then(([assessments, ui, languages, languagesTranslated]) => ({
      ...assessments.default,
      ...ui.default,
      ...languages.default,
      ...languagesTranslated.default
    })),
  enDefault
);
